// 首页界面接口
import { get, post, put, deletefn } from "./request";

// 合伙人账号管理界面接口
export const getcollaborateInfo = params => get(`/v1/manager/collaborate/collaborateInfo`, params)

// 合伙人账号管理界面接口审核
export const postupdateCollaborate = params => post(`/v1/manager/collaborate/updateCollaborate`, params)

// 合伙人账号管理界面接口查看密码
export const getPassword = params => get(`/v1/manager/collaborate/getPassword`, params)

// 合伙人收益
export const getcollaborateStaticInfo = params => get(`/v1/manager/collaborate/collaborateStaticInfo`, params)



// 合伙人收益管理界面 银行卡列表接口
export const getbankInfo = params => get(`/v1/manager/collaborate/bankInfo`, params)

// 合伙人管理界面 系统变量
export const getSysteminfo = params => get(`/v1/manager/collaborate/systeminfo`, params)

// 合伙人管理界面 修改系统变量
export const postSysteminfo = params => post(`/v1/manager/collaborate/systeminfoUpdate`, params)

// 审核管理 实名认证列表
export const getAuthentication = params => get(`/v1/manager/collaborate/authentication`, params)

// 审核管理 实名认证审核
export const postupdateAuthentication = params => post(`/v1/manager/collaborate/updateAuthentication`, params)


// 审核管理 银行卡列表
export const getBankInfo = params => get(`/v1/manager/collaborate/bankInfo`, params)
// 审核管理 银行卡审核
export const postUpdateBank = params => post(`/v1/manager/collaborate/updateBank`, params)



// 审核管理 提现审核 余额列表
export const getEarnest = params => get(`/v1/manager/earnest`, params)

// 审核管理 提现审核 余额列表
export const postEarnest = params => post(`/v1/manager/earnest/verify`, params)

// 审核管理 提现审核 合伙人提现列表
export const getBalance = params => get(`/v1/manager/balance`, params)

// 审核管理 提现审核 合伙人提现列表
export const postBalance = params => post(`/v1/manager/balance/verify`, params)

//押金充值取钱列表
export const getEarnetInfo = params => get(`/v1/manager/collaborate/earnetInfo`, params)

// 押金取钱充值审核
export const postUpdateEarnety= params => post(`/v1/manager/collaborate/updateEarnet`, params)

// 订单明细
export const getorderDetail= params => get(`/v1/manager/collaborate/orderDetail`, params)





